/**
 * Legacy display helpers — UTC API timestamps → device local time.
 * Prefer importing from `@/utils/dateUtils` (`formatLocalTime`, etc.).
 */
import {
  formatLocalTime,
  formatLocalTimeWithSeconds,
  formatLocalDateTime,
  formatTimeInTimeZone,
} from './dateUtils';

/**
 * Format time from UTC ISO.
 * @param {string} isoString
 * @param {string} [timeZone] optional IANA zone (e.g. staff.timezone for admin attendance)
 * @returns {string} e.g. "10:30 AM"
 */
export const formatTimeFromISO = (isoString, timeZone) =>
  timeZone
    ? formatTimeInTimeZone(isoString, timeZone)
    : formatLocalTime(isoString);

/**
 * Format time with seconds from UTC ISO in the viewer's local timezone.
 * @param {string} isoString
 * @returns {string} e.g. "10:30:45 AM"
 */
export const formatTimeWithSecondsFromISO = (isoString) =>
  formatLocalTimeWithSeconds(isoString);

/**
 * Format date and time from UTC ISO in the viewer's local timezone.
 * @param {string} isoString
 * @returns {string} e.g. "Jan 29, 2026, 10:30 AM"
 */
export const formatDateTimeFromISO = (isoString) => formatLocalDateTime(isoString);
